var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.dialogVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "三方订单信息",
                visible: _vm.dialogVisible,
                top: "2vh",
                "before-close": _vm.handleColse,
                width: "1000px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "description",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex-btw",
                      staticStyle: { "margin-bottom": "20px" },
                    },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("基础信息")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "flex" },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["admin:virtual:order:do:tag"],
                                  expression: "['admin:virtual:order:do:tag']",
                                },
                              ],
                              staticClass: "mr10",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.orderBindTag },
                            },
                            [_vm._v("订单打标")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["admin:virtual:order:do:update"],
                                  expression:
                                    "['admin:virtual:order:do:update']",
                                },
                              ],
                              staticClass: "mr10",
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.nextChangeOrder },
                            },
                            [_vm._v("订单维护")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["admin:virtual:order:do:callback"],
                                  expression:
                                    "['admin:virtual:order:do:callback']",
                                },
                              ],
                              staticClass: "mr10",
                              attrs: {
                                size: "mini",
                                type: "danger",
                                plain: "",
                              },
                              on: { click: _vm.callBackVirtual },
                            },
                            [_vm._v("手动回调")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "mr10",
                              attrs: {
                                size: "mini",
                                type: "danger",
                                plain: "",
                              },
                              on: { click: _vm.getVirtualState },
                            },
                            [_vm._v("订单查询")]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "acea-row" },
                    _vm._l(_vm.baseOption, function (item) {
                      return _c(
                        "div",
                        {
                          key: item.dataIndex,
                          staticClass: "description-term",
                          style: item.isFull ? "width: 100%;" : "",
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                item.title +
                                  "：" +
                                  (_vm.orderDatalist[item.dataIndex] || "--")
                              ) +
                              "\n\t\t\t\t\t"
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("el-divider"),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-btw" }, [
                    _c("div", { staticClass: "title" }, [_vm._v("流转日志")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        height: "350",
                        data: _vm.logLists,
                        size: "mini",
                        "highlight-current-row": "",
                        "header-cell-style": { fontWeight: "bold" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "content",
                          label: "描述",
                          "min-width": "600",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "opTime",
                          label: "更新时间",
                          "min-width": "200",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          label: "操作",
                          "min-width": "80",
                          fixed: "right",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "mr10",
                                      attrs: { size: "small", type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openReqDetail(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("详情")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1215424451
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("BindTag", {
                ref: "BindTagRef",
                attrs: { bindType: 1 },
                on: {
                  doRefresh: function ($event) {
                    return _vm.getOrderData(0)
                  },
                },
              }),
              _vm._v(" "),
              _c("NextThirdorder", {
                ref: "NextThirdorderRef",
                on: {
                  doRefresh: function ($event) {
                    return _vm.getOrderData(1)
                  },
                },
              }),
              _vm._v(" "),
              _c("LogDetail", { ref: "LogDetailRef" }),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "footer" }, slot: "footer" },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }